import { switchClasses } from '@mui/material';
import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiSwitch: Components<Omit<Theme, 'components'>>['MuiSwitch'] = {
  styleOverrides: {
    root: {
      [`& .${switchClasses.checked}:not(.${switchClasses.disabled})`]: {
        [`& .${switchClasses.thumb}`]: {
          background: 'linear-gradient(76deg, #0D1B27 1.48%, #1E2041 60.13%, #9747FF 115.1%)',
        },
        [`+ .${switchClasses.track}`]: {
          background: '#BDBFC3',
          opacity: '1',
        },
      },
      [`& .${switchClasses.checked}.${switchClasses.disabled}`]: {
        [`& .${switchClasses.thumb}`]: {
          background: '#CFD8DD',
        },
        [`+ .${switchClasses.track}`]: {
          background: '#E7E8E9',
          opacity: '1',
        },
      },
      [`& :not(.${switchClasses.checked}):not(.${switchClasses.disabled})`]: {
        [`& .${switchClasses.thumb}`]: {
          background: '#DEE2E4',
        },
        [`+ .${switchClasses.track}`]: {
          background: '#BDBFC3',
          opacity: '1',
        },
      },
    },
  },
};
